import Taro, { showLoading, hideLoading, showToast } from '@tarojs/taro';
import { trainingSave as apiTrainingSave, trainingUpdate, trainingDetail as apiTrainingDetail } from '@/service/training';
import type { TrainingFormData } from './types';
import {  xcxTaskReportDetail } from '@/service/user';
/**
 * 保存培训数据
 */
export const trainingSave = async (data: TrainingFormData) => {
  Taro.showLoading({ title: '提交中...' });
  try {
    // 构建提交数据
    const submitData = {
      topic: data.topic,
      trainingTime: typeof data.trainingTime === 'string' ? data.trainingTime : data.trainingTime.toISOString(),
      participants: data.participants, // 直接使用字符串
      remark: data.remark,
      uploadFiles: data.uploadFiles,
      submitDate: typeof data.submitDate === 'string' ? data.submitDate : data.submitDate.toISOString(),
    };

    let result;
    if (data.id) {
      // 编辑模式
      result = await trainingUpdate({ ...submitData, id: data.id });
    } else {
      // 新增模式
      result = await apiTrainingSave(submitData);
    }

    if (result.success) {
      return {
        success: true,
        data: result.data,
        msg: '保存成功'
      };
    } else {
      return {
        success: false,
        msg: result.msg || '保存失败'
      };
    }
  } catch (error) {
    console.error('保存培训数据失败', error);
    showToast({ title: '保存失败', icon: 'none' });
    return { success: false, msg: '保存失败' };
  } finally {
    Taro.hideLoading();
  }
};

/**
 * 获取培训详情
 */
export const trainingDetail = async (params: { reportId: string }) => {
  const { reportId } = params;
  if (!reportId) return null;

  showLoading({ title: '获取详情中...' });

  try {
    const result = await xcxTaskReportDetail({reportId});

    if (result.success && result.data) {
      return result.data;
    } else {
      showToast({ title: '获取详情失败', icon: 'none' });
      return null;
    }
  } catch (error) {
    console.error('获取培训详情失败', error);
    showToast({ title: '获取详情失败', icon: 'none' });
    return null;
  } finally {
    hideLoading();
  }
};


